export enum NTPEObservationStatus {
    PendingApproval = 97,
    InProgress = 98,
    PendingRating = 99,
    PendingTargetAuthentication = 100,
    PendingEvaluatorAuthentication = 101,
    Authenticated = 102
}